// import React, { useState, useEffect } from 'react';
// import styled, { keyframes, css } from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import { 
//   FaUsers, FaFileAlt, FaChevronRight, FaCheckCircle, 
//   FaUserCog, FaLock, FaArrowLeft, FaUserEdit, FaEye, 
//   FaEyeSlash, FaClipboardCheck, FaShieldAlt, FaCrown, 
//   FaGlobe, FaChartLine, FaClock 
// } from 'react-icons/fa';
// import NavBarSuper from './NavBarSuper'; // Assuming Admin uses the same sidebar style
// import Footer from './Footer';
// import api from '../api';
// import { useTheme } from '../App'; 

// const backendUrl = "https://api.stdl.site"; 

// /* ================= ANIMATIONS ================= */
// const float = keyframes`
//   0% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-12px) rotate(2deg); }
//   100% { transform: translateY(0px) rotate(0deg); }
// `;

// const slideUp = keyframes`
//   from { opacity: 0; transform: translateY(20px); }
//   to { opacity: 1; transform: translateY(0); }
// `;

// const pulseGold = keyframes`
//   0% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.4); }
//   70% { box-shadow: 0 0 0 12px rgba(251, 191, 36, 0); }
//   100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0); }
// `;

// /* ================= ROOT THEME WRAPPER ================= */
// const ThemeWrapper = styled.div`
//   --bg-main: ${({ $isDarkMode }) => $isDarkMode ? '#050505' : '#f8fafc'};
//   --bg-card: ${({ $isDarkMode }) => $isDarkMode ? '#171717' : '#ffffff'};
//   --bg-card-hover: ${({ $isDarkMode }) => $isDarkMode ? '#262626' : '#f1f5f9'};
//   --text-primary: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-secondary: ${({ $isDarkMode }) => $isDarkMode ? '#a1a1aa' : '#64748b'};
//   --border-color: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)'};
  
//   /* Admin Gold Palette */
//   --admin-gold: #fbbf24;
//   --admin-gold-light: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : '#fef3c7'};
//   --admin-dark: #0f172a;
  
//   background-color: var(--bg-main);
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   overflow-x: hidden;
// `;

// const PageContainer = styled.main`
//   flex: 1;
//   box-sizing: border-box;
//   padding: 120px 40px 80px; 
//   transition: margin-left 0.35s ease, width 0.35s ease;

//   @media (max-width: 1024px) {
//     margin-left: 0;
//     width: 100%;
//     padding: 110px 20px 80px; 
//   }
// `;

// const InnerWrap = styled.div`
//   width: 100%;
//   max-width: 1600px;
//   margin: 0 auto;
// `;

// /* ================= EXECUTIVE HERO BANNER ================= */
// const HeroBanner = styled.div`
//   background: ${({ $isDarkMode }) => $isDarkMode ? 
//     'linear-gradient(135deg, #09090b 0%, #1e1b4b 100%)' : 
//     'linear-gradient(135deg, #0f172a 0%, #312e81 100%)'};
//   border-radius: 24px;
//   padding: 48px;
//   position: relative;
//   overflow: hidden;
//   box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
//   margin-bottom: 40px;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   flex-wrap: wrap;
//   gap: 30px;
//   width: 100%;
//   box-sizing: border-box;
//   animation: ${slideUp} 0.5s ease-out forwards;
//   border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : 'transparent'};

//   &::before {
//     content: ""; position: absolute; top: -50px; right: -50px; width: 400px; height: 400px;
//     background: radial-gradient(circle, rgba(251, 191, 36, 0.15) 0%, rgba(251, 191, 36, 0) 70%);
//     border-radius: 50%; animation: ${float} 8s ease-in-out infinite;
//   }
//   @media (max-width: 768px) { padding: 30px 20px; border-radius: 20px; flex-direction: column; align-items: stretch; }
// `;

// const HeroProfile = styled.div`
//   display: flex; align-items: center; gap: 28px; position: relative; z-index: 2;
//   @media (max-width: 576px) { flex-direction: column; align-items: flex-start; gap: 16px; }
// `;

// const AvatarRing = styled.div`
//   width: 96px; height: 96px; border-radius: 24px; padding: 3px;
//   background: linear-gradient(135deg, #fbbf24, #f59e0b); flex-shrink: 0;
//   box-shadow: 0 10px 25px rgba(251, 191, 36, 0.2);
//   img, div {
//     width: 100%; height: 100%; border-radius: 20px; object-fit: cover;
//     background: var(--bg-card); display: grid; place-items: center;
//     color: var(--admin-gold); font-size: 2.5rem; font-weight: 900;
//   }
// `;

// const HeroTextInfo = styled.div` color: white; `;
// const SuperBadge = styled.span`
//   display: inline-flex; align-items: center; gap: 8px; background: rgba(251, 191, 36, 0.15); backdrop-filter: blur(8px);
//   padding: 8px 16px; border-radius: 999px; font-size: 0.75rem; font-weight: 900; color: #fbbf24;
//   text-transform: uppercase; margin-bottom: 12px; border: 1px solid rgba(251, 191, 36, 0.3); letter-spacing: 1px;
// `;
// const WelcomeTitle = styled.h1` margin: 0 0 8px; font-size: clamp(1.8rem, 2.5vw, 2.5rem); font-weight: 900; line-height: 1.2; `;
// const WelcomeSub = styled.p` margin: 0; color: rgba(255,255,255,0.7); font-size: 1rem; max-width: 550px; line-height: 1.6; `;

// /* ================= MODERN SCORECARDS ================= */
// const ScorecardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px; margin-bottom: 40px; `;

// const ScoreCard = styled.div`
//   background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 20px;
//   padding: 32px 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); display: flex; align-items: center; gap: 20px; transition: all 0.3s ease;
//   position: relative; overflow: hidden;
  
//   ${({ $isPulsing }) => $isPulsing && css` animation: ${pulseGold} 2s infinite; border-color: rgba(251, 191, 36, 0.5); `}

//   &:hover { transform: translateY(-4px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); border-color: ${({ highlight }) => highlight || 'var(--border-color)'}; }
//   &::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: ${({ highlight }) => highlight || 'transparent'}; }
// `;

// const IconWrapper = styled.div`
//   width: 64px; height: 64px; border-radius: 16px; background: ${({ bg }) => bg || 'var(--admin-gold-light)'};
//   color: ${({ color }) => color || 'var(--admin-gold)'}; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; flex-shrink: 0;
// `;

// const ScoreData = styled.div` display: flex; flex-direction: column; `;
// const ScoreNumber = styled.div` font-size: 2.5rem; font-weight: 900; color: var(--text-primary); line-height: 1; margin-bottom: 8px; letter-spacing: -1px; `;
// const ScoreText = styled.div` font-size: 0.85rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.5px; `;

// const ProgressCircle = styled.div`
//   width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;
//   background: conic-gradient( #fbbf24 ${({ percentage }) => percentage}%, var(--border-color) 0 );
//   &::after { content: ""; width: 50px; height: 50px; background: var(--bg-card); border-radius: 50%; position: absolute; }
//   span { position: relative; z-index: 1; font-size: 1rem; font-weight: 900; color: var(--text-primary); }
// `;

// /* ================= QUICK ACTIONS (BOTTOM) ================= */
// const QuickActionsGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-bottom: 40px; `;

// const ActionBtn = styled.button`
//   background: var(--bg-card); border: 1px solid var(--border-color); padding: 24px; border-radius: 20px;
//   display: flex; align-items: center; gap: 20px; cursor: pointer; transition: all 0.3s ease; text-align: left; width: 100%;
//   &:hover { transform: translateY(-4px); border-color: var(--admin-gold); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
//   .icon-box { width: 52px; height: 52px; border-radius: 16px; background: var(--admin-gold-light); color: var(--admin-gold); display: flex; align-items: center; justify-content: center; font-size: 1.3rem; flex-shrink: 0; }
//   .text-box h3 { margin: 0 0 6px; font-size: 1.1rem; color: var(--text-primary); font-weight: 800; }
//   .text-box p { margin: 0; font-size: 0.85rem; color: var(--text-secondary); line-height: 1.4; }
// `;

// /* ================= CONTENT SECTIONS ================= */
// const SectionCard = styled.div` background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 24px; padding: 32px; margin-bottom: 40px; @media (max-width: 768px) { padding: 24px; } `;
// const SectionHeader = styled.div` display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; flex-wrap: wrap; gap: 16px; `;
// const SectionTitle = styled.h2` margin: 0; font-size: 1.4rem; font-weight: 900; color: var(--text-primary); display: flex; align-items: center; gap: 12px; `;
// const Badge = styled.div` background: var(--admin-gold-light); color: #b45309; padding: 6px 14px; border-radius: 999px; font-weight: 800; font-size: 0.85rem; border: 1px solid rgba(251, 191, 36, 0.3);`;
// const CardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 24px; `;

// const ItemCard = styled.div`
//   background: var(--bg-main); border: 1px solid var(--border-color); border-radius: 16px; padding: 24px;
//   display: flex; flex-direction: column; gap: 16px; cursor: pointer; transition: all 0.2s;
//   &:hover { border-color: var(--admin-gold); transform: translateY(-4px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
// `;

// const CardTop = styled.div` display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; `;
// const NameText = styled.h3` margin: 0 0 6px; font-size: 1.15rem; font-weight: 800; color: var(--text-primary); `;
// const SubText = styled.p` margin: 2px 0; font-size: 0.9rem; color: var(--text-secondary); span { font-weight: 700; color: var(--text-primary); } `;

// const StatusPill = styled.div`
//   padding: 6px 12px; border-radius: 999px; font-size: 0.75rem; font-weight: 800; display: flex; align-items: center; gap: 6px; white-space: nowrap;
//   background: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? 'rgba(16,185,129,0.15)' : '#dcfce7') : 'var(--admin-gold-light)'};
//   color: ${({ ready, $isDarkMode }) => ready ? ($isDarkMode ? '#34d399' : '#059669') : '#b45309'};
// `;

// const CardBottom = styled.div` display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid var(--border-color); margin-top: auto; `;
// const OutlineBtn = styled.button` background: transparent; color: var(--text-primary); border: 1px solid var(--border-color); border-radius: 10px; padding: 10px 16px; font-weight: 800; font-size: 0.9rem; cursor: pointer; width: 100%; display: flex; justify-content: center; align-items: center; gap: 8px; transition: all 0.2s; &:hover { border-color: var(--admin-gold); background: var(--admin-gold-light); color: #b45309; } `;

// /* ================= INLINE SETTINGS STYLES ================= */
// const BackButton = styled.button` display: flex; align-items: center; gap: 8px; background: transparent; color: var(--text-secondary); border: none; font-size: 1rem; font-weight: 800; cursor: pointer; margin-bottom: 24px; transition: color 0.2s; &:hover { color: var(--admin-gold); } `;
// const Form = styled.form` display: flex; flex-direction: column; gap: 24px; max-width: 700px; `;
// const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
// const Label = styled.label` font-size: 0.95rem; font-weight: 800; color: var(--text-primary); `;
// const Input = styled.input` width: 100%; padding: 16px; border-radius: 12px; border: 1px solid var(--border-color); font-size: 1rem; background: var(--bg-main); color: var(--text-primary); transition: all 0.2s; box-sizing: border-box; &:focus { border-color: var(--admin-gold); outline: none; } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
// const SubmitBtn = styled.button` background: var(--admin-dark); color: white; border: 1px solid rgba(255,255,255,0.1); padding: 16px 32px; border-radius: 12px; font-size: 1rem; font-weight: 800; cursor: pointer; align-self: flex-start; transition: all 0.2s; &:hover:not(:disabled) { background: #000; transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.1); border-color: var(--admin-gold); color: var(--admin-gold); } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
// const Message = styled.div` padding: 16px; border-radius: 12px; font-weight: 700; background: ${({ type }) => type === 'success' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)'}; color: ${({ type }) => type === 'success' ? '#10b981' : '#ef4444'}; border: 1px solid currentColor; margin-bottom: 24px; `;

// /* ================= MAIN COMPONENT ================= */
// const AdminDashboard = ({ user, setUser }) => {
//   const { isDarkMode } = useTheme();
//   const [collapsed, setCollapsed] = useState(false);
//   const navigate = useNavigate();

//   const [activeView, setActiveView] = useState('dashboard'); 
//   const [appraisals, setAppraisals] = useState([]);
//   const [allUsers, setAllUsers] = useState([]); 
//   const [loading, setLoading] = useState(true);

//   // Forms
//   const [profileData, setProfileData] = useState({ username: user?.username || user?.name || "", email: user?.email || "" });
//   const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });
//   const [passwordData, setPasswordData] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
//   const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });
//   const [showPwd, setShowPwd] = useState(false);

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         setLoading(true);
//         // Admin also fetches all-staff, similar to Super Admin
//         const [appRes, usersRes] = await Promise.all([
//           // api.get('/appraisal/admin/all'), // Adjust endpoint if your admin route differs
//           api.get('/auth/all-staff')
//         ]);
//         // setAppraisals(appRes.data.data || []);
//         setAllUsers(usersRes.data.data || []);
//       } catch (err) { 
//         console.error(err);
//       } finally { 
//         setLoading(false); 
//       }
//     };
//     fetchDashboardData();
//   }, []);

//   const displayName = `${user?.title?.trim() || ""} ${user?.firstName?.trim() || user?.name || "Admin"}`.trim();
//   const initials = (user?.firstName || user?.name || "A").substring(0, 2).toUpperCase();

//   const totalStaff = allUsers.length;
//   const totalAppraisals = appraisals.length; 
//   const readyCount = appraisals.filter(a => a.readyToBeScored).length;
//   const actionRate = totalAppraisals > 0 ? Math.round((readyCount / totalAppraisals) * 100) : 0;

//   const handleProfileSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await api.put('/auth/profile', { email: profileData.email });
//       if (res.data.success) {
//         const fetchRes = await api.get("/auth/profile");
//         if (fetchRes.data.success) {
//           localStorage.setItem("user", JSON.stringify(fetchRes.data.user));
//           if (setUser) setUser(fetchRes.data.user);
//         }
//         setProfileMsg({ type: "success", text: "Profile updated successfully!" });
//       }
//     } catch (err) { setProfileMsg({ type: "error", text: "Failed to update profile." }); }
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     if (passwordData.newPassword !== passwordData.confirmPassword) return setPasswordMsg({ type: "error", text: "Passwords don't match." });
//     try {
//       await api.put('/auth/change-password', { currentPassword: passwordData.currentPassword, newPassword: passwordData.newPassword });
//       setPasswordMsg({ type: "success", text: "Password changed securely." });
//       setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
//     } catch (err) { setPasswordMsg({ type: "error", text: "Failed to change password." }); }
//   };

//   return (
//     <ThemeWrapper collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      
//       <PageContainer collapsed={collapsed}>
//         <InnerWrap>
//           {/* ================= HERO BANNER ================= */}
//           <HeroBanner $isDarkMode={isDarkMode}>
//             <HeroProfile>
//               <AvatarRing>
//                 {user?.profilePicture ? (
//                   <img src={user.profilePicture.startsWith("http") ? user.profilePicture : `${backendUrl}${user.profilePicture}`} alt="Avatar" onError={(e) => e.target.style.display="none"} />
//                 ) : ( <div>{initials}</div> )}
//               </AvatarRing>
//               <HeroTextInfo>
//                 <SuperBadge><FaCrown /> Admin Matrix</SuperBadge>
//                 <WelcomeTitle>
//                   {activeView === 'dashboard' ? `Welcome back, ${displayName}` : 
//                   activeView === 'profile' ? 'Profile Management' : 'Security Protocol'}
//                 </WelcomeTitle>
//                 <WelcomeSub>
//                   {activeView === 'dashboard' ? 'You have administrative oversight. Monitor global organization metrics, company-wide appraisals, and total workforce data.' :
//                   'Manage your admin-level account configurations securely.'}
//                 </WelcomeSub>
//               </HeroTextInfo>
//             </HeroProfile>
//           </HeroBanner>

//           {/* ================= PROFILE SETTINGS VIEW ================= */}
//           {activeView === 'profile' && (
//             <div>
//               <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Matrix</BackButton>
//               <SectionCard>
//                 <SectionHeader><SectionTitle><FaUserEdit style={{color: 'var(--admin-gold)'}} /> Edit Profile</SectionTitle></SectionHeader>
//                 {profileMsg.text && <Message type={profileMsg.type}>{profileMsg.text}</Message>}
//                 <Form onSubmit={handleProfileSubmit}>
//                   <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
//                     <FormGroup style={{ flex: 1, minWidth: '250px' }}>
//                       <Label>Username (Locked)</Label>
//                       <Input type="text" value={profileData.username} disabled />
//                     </FormGroup>
//                     <FormGroup style={{ flex: 1, minWidth: '250px' }}>
//                       <Label>Email Address</Label>
//                       <Input type="email" value={profileData.email} onChange={(e) => setProfileData({...profileData, email: e.target.value})} required />
//                     </FormGroup>
//                   </div>
//                   <SubmitBtn type="submit">Save Configurations</SubmitBtn>
//                 </Form>
//               </SectionCard>
//             </div>
//           )}

//           {/* ================= SECURITY VIEW ================= */}
//           {activeView === 'security' && (
//             <div>
//               <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Matrix</BackButton>
//               <SectionCard>
//                 <SectionHeader><SectionTitle><FaShieldAlt style={{color: 'var(--admin-gold)'}} /> Security Protocol</SectionTitle></SectionHeader>
//                 {passwordMsg.text && <Message type={passwordMsg.type}>{passwordMsg.text}</Message>}
//                 <Form onSubmit={handlePasswordSubmit}>
//                   <FormGroup>
//                     <Label>Current Password</Label>
//                     <div style={{position: 'relative'}}>
//                       <Input type={showPwd ? "text" : "password"} value={passwordData.currentPassword} onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})} required />
//                       <button type="button" onClick={() => setShowPwd(!showPwd)} style={{position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '1.2rem'}}>{showPwd ? <FaEyeSlash/> : <FaEye/>}</button>
//                     </div>
//                   </FormGroup>
//                   <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
//                     <FormGroup style={{ flex: 1, minWidth: '250px' }}>
//                       <Label>New Password</Label>
//                       <Input type={showPwd ? "text" : "password"} value={passwordData.newPassword} onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})} required />
//                     </FormGroup>
//                     <FormGroup style={{ flex: 1, minWidth: '250px' }}>
//                       <Label>Confirm Password</Label>
//                       <Input type={showPwd ? "text" : "password"} value={passwordData.confirmPassword} onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})} required />
//                     </FormGroup>
//                   </div>
//                   <SubmitBtn type="submit">Update Security Key</SubmitBtn>
//                 </Form>
//               </SectionCard>
//             </div>
//           )}

//           {/* ================= DASHBOARD VIEW ================= */}
//           {activeView === 'dashboard' && (
//             <>
//               {/* 🔥 EXECUTIVE SCORECARDS */}
//               <ScorecardGrid>
//                 <ScoreCard highlight="#3b82f6">
//                   <IconWrapper bg="rgba(59, 130, 246, 0.1)" color="#3b82f6"><FaGlobe /></IconWrapper>
//                   <ScoreData><ScoreNumber>{loading ? '-' : totalStaff}</ScoreNumber><ScoreText>Total Workforce</ScoreText></ScoreData>
//                 </ScoreCard>

//                 <ScoreCard highlight="#fbbf24">
//                   <IconWrapper bg="var(--admin-gold-light)" color="var(--admin-gold)"><FaFileAlt /></IconWrapper>
//                   <ScoreData><ScoreNumber>{loading ? '-' : totalAppraisals}</ScoreNumber><ScoreText>Total Appraisals</ScoreText></ScoreData>
//                 </ScoreCard>

//                 <ScoreCard highlight="#10b981" $isPulsing={readyCount > 0}>
//                   <IconWrapper bg="rgba(16, 185, 129, 0.1)" color="#10b981"><FaClipboardCheck /></IconWrapper>
//                   <ScoreData><ScoreNumber>{loading ? '-' : readyCount}</ScoreNumber><ScoreText>Global Ready</ScoreText></ScoreData>
//                 </ScoreCard>

//                 <ScoreCard highlight="#8b5cf6">
//                   <ProgressCircle percentage={actionRate || 0}><span>{loading ? '-' : `${actionRate}%`}</span></ProgressCircle>
//                   <ScoreData><ScoreNumber style={{fontSize: '1.4rem'}}>System Rate</ScoreNumber><ScoreText style={{textTransform: 'none'}}>Appraisals Ready</ScoreText></ScoreData>
//                 </ScoreCard>
//               </ScorecardGrid>

//               {/* GLOBAL DIRECTORY */}
//               <SectionCard>
//                 <SectionHeader>
//                   <SectionTitle><FaUsers style={{color: 'var(--admin-gold)'}} /> Global Workforce</SectionTitle>
//                   <Badge>{allUsers.length} Active Staff</Badge>
//                 </SectionHeader>
//                 <CardGrid>
//                   {allUsers.map((staff) => (
//                     // 🔥 Navigates to /admin/goals/ instead of /super-admin/goals/
//                     <ItemCard key={staff._id} onClick={() => navigate(`/admin/goals/${staff._id}`)}>
//                       <CardTop>
//                         <div>
//                           <NameText>{staff.firstName} {staff.surname}</NameText>
//                           <SubText>Role: <span>{staff.roles || 'N/A'}</span></SubText>
//                           <SubText>Unit: <span>{staff.unit || 'N/A'}</span></SubText>
//                         </div>
//                       </CardTop>
//                       <CardBottom>
//                         <OutlineBtn>Inspect Performance <FaChevronRight size={10}/></OutlineBtn>
//                       </CardBottom>
//                     </ItemCard>
//                   ))}
//                 </CardGrid>
//               </SectionCard>

//               {/* GLOBAL APPRAISALS */}
//               <SectionCard>
//                 <SectionHeader>
//                   <SectionTitle><FaChartLine style={{color: 'var(--admin-gold)'}} /> Master Appraisals Log</SectionTitle>
//                   <Badge>{appraisals.length} Total Records</Badge>
//                 </SectionHeader>
//                 <CardGrid>
//                   {appraisals.map((appraisal) => {
//                     const staffInfo = appraisal.userId || appraisal.user || appraisal.userDetails || {};
//                     const isReady = appraisal.readyToBeScored || false;
//                     return (
//                       // 🔥 Navigates to /admin/appraisal/ instead of /super-admin/appraisal/
//                       <ItemCard key={appraisal._id} onClick={() => navigate(`/admin/appraisal/${appraisal._id}`)}>
//                         <CardTop>
//                           <div>
//                             <NameText>{staffInfo.firstName ? `${staffInfo.firstName} ${staffInfo.surname}` : 'Unknown Record'}</NameText>
//                             <SubText>Cycle: <span>{appraisal.appraisalPeriod}</span></SubText>
//                           </div>
//                           <StatusPill ready={isReady} $isDarkMode={isDarkMode}>
//                             {isReady ? <><FaCheckCircle/> Action Required</> : <><FaClock/> In Progress</>}
//                           </StatusPill>
//                         </CardTop>
//                         <CardBottom>
//                           <SubText style={{fontSize: '0.8rem'}}>Last Sync: {new Date(appraisal.updatedAt).toLocaleDateString()}</SubText>
//                           <div style={{color: isReady ? 'var(--accent-green)' : 'var(--admin-gold)', fontWeight: 800, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '4px'}}>
//                             {isReady ? 'Evaluate' : 'View Record'} <FaChevronRight size={10} />
//                           </div>
//                         </CardBottom>
//                       </ItemCard>
//                     );
//                   })}
//                 </CardGrid>
//               </SectionCard>

//               {/* ACCOUNT MANAGEMENT (No Logout) */}
//               <SectionHeader style={{ marginTop: '50px' }}>
//                 <SectionTitle><FaShieldAlt style={{color: 'var(--admin-gold)'}} /> Administrator Protocol</SectionTitle>
//               </SectionHeader>
//               <QuickActionsGrid>
//                 <ActionBtn onClick={() => setActiveView('profile')}>
//                   <div className="icon-box"><FaUserCog /></div>
//                   <div className="text-box"><h3>Modify Credentials</h3><p>Update your global identity.</p></div>
//                 </ActionBtn>
//                 <ActionBtn onClick={() => setActiveView('security')}>
//                   <div className="icon-box"><FaLock /></div>
//                   <div className="text-box"><h3>Security Matrix</h3><p>Manage access protocols.</p></div>
//                 </ActionBtn>
//               </QuickActionsGrid>

//             </>
//           )}
//         </InnerWrap>
//       </PageContainer>
//       <Footer />
//     </ThemeWrapper>
//   );
// };

// export default AdminDashboard;









import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { 
  FaUsers, FaChevronRight, FaUserCog, FaLock, 
  FaArrowLeft, FaUserEdit, FaEye, FaEyeSlash, 
  FaShieldAlt, FaCrown, FaGlobe 
} from 'react-icons/fa';
import NavBarSuper from './NavBarSuper';
import Footer from './Footer';
import api from '../api';
import { useTheme } from '../App'; 

const backendUrl = "https://api.stdl.site"; 

/* ================= ANIMATIONS ================= */
const float = keyframes`
  0% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-12px) rotate(2deg); }
  100% { transform: translateY(0px) rotate(0deg); }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulseGold = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0.4); }
  70% { box-shadow: 0 0 0 12px rgba(251, 191, 36, 0); }
  100% { box-shadow: 0 0 0 0 rgba(251, 191, 36, 0); }
`;

/* ================= ROOT THEME WRAPPER ================= */
const ThemeWrapper = styled.div`
  --bg-main: ${({ $isDarkMode }) => $isDarkMode ? '#050505' : '#f8fafc'};
  --bg-card: ${({ $isDarkMode }) => $isDarkMode ? '#171717' : '#ffffff'};
  --bg-card-hover: ${({ $isDarkMode }) => $isDarkMode ? '#262626' : '#f1f5f9'};
  --text-primary: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-secondary: ${({ $isDarkMode }) => $isDarkMode ? '#a1a1aa' : '#64748b'};
  --border-color: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)'};
  
  /* Admin Gold Palette */
  --admin-gold: #fbbf24;
  --admin-gold-light: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : '#fef3c7'};
  --admin-dark: #0f172a;
  
  background-color: var(--bg-main);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: hidden;
`;

const PageContainer = styled.main`
  flex: 1;
  box-sizing: border-box;
  padding: 120px 40px 80px; 
  transition: margin-left 0.35s ease, width 0.35s ease;

  @media (max-width: 1024px) {
    margin-left: 0;
    width: 100%;
    padding: 110px 20px 80px; 
  }
`;

const InnerWrap = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
`;

/* ================= EXECUTIVE HERO BANNER ================= */
const HeroBanner = styled.div`
  background: ${({ $isDarkMode }) => $isDarkMode ? 
    'linear-gradient(135deg, #09090b 0%, #1e1b4b 100%)' : 
    'linear-gradient(135deg, #0f172a 0%, #312e81 100%)'};
  border-radius: 24px;
  padding: 48px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  width: 100%;
  box-sizing: border-box;
  animation: ${slideUp} 0.5s ease-out forwards;
  border: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(251, 191, 36, 0.1)' : 'transparent'};

  &::before {
    content: ""; position: absolute; top: -50px; right: -50px; width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(251, 191, 36, 0.15) 0%, rgba(251, 191, 36, 0) 70%);
    border-radius: 50%; animation: ${float} 8s ease-in-out infinite;
  }
  @media (max-width: 768px) { padding: 30px 20px; border-radius: 20px; flex-direction: column; align-items: stretch; }
`;

const HeroProfile = styled.div`
  display: flex; align-items: center; gap: 28px; position: relative; z-index: 2;
  @media (max-width: 576px) { flex-direction: column; align-items: flex-start; gap: 16px; }
`;

const AvatarRing = styled.div`
  width: 96px; height: 96px; border-radius: 24px; padding: 3px;
  background: linear-gradient(135deg, #fbbf24, #f59e0b); flex-shrink: 0;
  box-shadow: 0 10px 25px rgba(251, 191, 36, 0.2);
  img, div {
    width: 100%; height: 100%; border-radius: 20px; object-fit: cover;
    background: var(--bg-card); display: grid; place-items: center;
    color: var(--admin-gold); font-size: 2.5rem; font-weight: 900;
  }
`;

const HeroTextInfo = styled.div` color: white; `;
const SuperBadge = styled.span`
  display: inline-flex; align-items: center; gap: 8px; background: rgba(251, 191, 36, 0.15); backdrop-filter: blur(8px);
  padding: 8px 16px; border-radius: 999px; font-size: 0.75rem; font-weight: 900; color: #fbbf24;
  text-transform: uppercase; margin-bottom: 12px; border: 1px solid rgba(251, 191, 36, 0.3); letter-spacing: 1px;
`;
const WelcomeTitle = styled.h1` margin: 0 0 8px; font-size: clamp(1.8rem, 2.5vw, 2.5rem); font-weight: 900; line-height: 1.2; `;
const WelcomeSub = styled.p` margin: 0; color: rgba(255,255,255,0.7); font-size: 1rem; max-width: 550px; line-height: 1.6; `;

/* ================= MODERN SCORECARDS ================= */
const ScorecardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px; margin-bottom: 40px; `;

const ScoreCard = styled.div`
  background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 20px;
  padding: 32px 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); display: flex; align-items: center; gap: 20px; transition: all 0.3s ease;
  position: relative; overflow: hidden;
  
  ${({ $isPulsing }) => $isPulsing && css` animation: ${pulseGold} 2s infinite; border-color: rgba(251, 191, 36, 0.5); `}

  &:hover { transform: translateY(-4px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); border-color: ${({ highlight }) => highlight || 'var(--border-color)'}; }
  &::before { content: ""; position: absolute; left: 0; top: 0; bottom: 0; width: 4px; background: ${({ highlight }) => highlight || 'transparent'}; }
`;

const IconWrapper = styled.div`
  width: 64px; height: 64px; border-radius: 16px; background: ${({ bg }) => bg || 'var(--admin-gold-light)'};
  color: ${({ color }) => color || 'var(--admin-gold)'}; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; flex-shrink: 0;
`;

const ScoreData = styled.div` display: flex; flex-direction: column; `;
const ScoreNumber = styled.div` font-size: 2.5rem; font-weight: 900; color: var(--text-primary); line-height: 1; margin-bottom: 8px; letter-spacing: -1px; `;
const ScoreText = styled.div` font-size: 0.85rem; font-weight: 700; color: var(--text-secondary); text-transform: uppercase; letter-spacing: 0.5px; `;

/* ================= QUICK ACTIONS (BOTTOM) ================= */
const QuickActionsGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-bottom: 40px; `;

const ActionBtn = styled.button`
  background: var(--bg-card); border: 1px solid var(--border-color); padding: 24px; border-radius: 20px;
  display: flex; align-items: center; gap: 20px; cursor: pointer; transition: all 0.3s ease; text-align: left; width: 100%;
  &:hover { transform: translateY(-4px); border-color: var(--admin-gold); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
  .icon-box { width: 52px; height: 52px; border-radius: 16px; background: var(--admin-gold-light); color: var(--admin-gold); display: flex; align-items: center; justify-content: center; font-size: 1.3rem; flex-shrink: 0; }
  .text-box h3 { margin: 0 0 6px; font-size: 1.1rem; color: var(--text-primary); font-weight: 800; }
  .text-box p { margin: 0; font-size: 0.85rem; color: var(--text-secondary); line-height: 1.4; }
`;

/* ================= CONTENT SECTIONS ================= */
const SectionCard = styled.div` background: var(--bg-card); border: 1px solid var(--border-color); border-radius: 24px; padding: 32px; margin-bottom: 40px; @media (max-width: 768px) { padding: 24px; } `;
const SectionHeader = styled.div` display: flex; justify-content: space-between; align-items: center; margin-bottom: 32px; flex-wrap: wrap; gap: 16px; `;
const SectionTitle = styled.h2` margin: 0; font-size: 1.4rem; font-weight: 900; color: var(--text-primary); display: flex; align-items: center; gap: 12px; `;
const Badge = styled.div` background: var(--admin-gold-light); color: #b45309; padding: 6px 14px; border-radius: 999px; font-weight: 800; font-size: 0.85rem; border: 1px solid rgba(251, 191, 36, 0.3);`;
const CardGrid = styled.div` display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 24px; `;

const ItemCard = styled.div`
  background: var(--bg-main); border: 1px solid var(--border-color); border-radius: 16px; padding: 24px;
  display: flex; flex-direction: column; gap: 16px; cursor: pointer; transition: all 0.2s;
  &:hover { border-color: var(--admin-gold); transform: translateY(-4px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
`;

const CardTop = styled.div` display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; `;
const NameText = styled.h3` margin: 0 0 6px; font-size: 1.15rem; font-weight: 800; color: var(--text-primary); `;
const SubText = styled.p` margin: 2px 0; font-size: 0.9rem; color: var(--text-secondary); span { font-weight: 700; color: var(--text-primary); } `;

const CardBottom = styled.div` display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px solid var(--border-color); margin-top: auto; `;
const OutlineBtn = styled.button` background: transparent; color: var(--text-primary); border: 1px solid var(--border-color); border-radius: 10px; padding: 10px 16px; font-weight: 800; font-size: 0.9rem; cursor: pointer; width: 100%; display: flex; justify-content: center; align-items: center; gap: 8px; transition: all 0.2s; &:hover { border-color: var(--admin-gold); background: var(--admin-gold-light); color: #b45309; } `;

/* ================= INLINE SETTINGS STYLES ================= */
const BackButton = styled.button` display: flex; align-items: center; gap: 8px; background: transparent; color: var(--text-secondary); border: none; font-size: 1rem; font-weight: 800; cursor: pointer; margin-bottom: 24px; transition: color 0.2s; &:hover { color: var(--admin-gold); } `;
const Form = styled.form` display: flex; flex-direction: column; gap: 24px; max-width: 700px; `;
const FormGroup = styled.div` display: flex; flex-direction: column; gap: 8px; `;
const Label = styled.label` font-size: 0.95rem; font-weight: 800; color: var(--text-primary); `;
const Input = styled.input` width: 100%; padding: 16px; border-radius: 12px; border: 1px solid var(--border-color); font-size: 1rem; background: var(--bg-main); color: var(--text-primary); transition: all 0.2s; box-sizing: border-box; &:focus { border-color: var(--admin-gold); outline: none; } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
const SubmitBtn = styled.button` background: var(--admin-dark); color: white; border: 1px solid rgba(255,255,255,0.1); padding: 16px 32px; border-radius: 12px; font-size: 1rem; font-weight: 800; cursor: pointer; align-self: flex-start; transition: all 0.2s; &:hover:not(:disabled) { background: #000; transform: translateY(-2px); box-shadow: 0 4px 10px rgba(0,0,0,0.1); border-color: var(--admin-gold); color: var(--admin-gold); } &:disabled { opacity: 0.6; cursor: not-allowed; } `;
const Message = styled.div` padding: 16px; border-radius: 12px; font-weight: 700; background: ${({ type }) => type === 'success' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)'}; color: ${({ type }) => type === 'success' ? '#10b981' : '#ef4444'}; border: 1px solid currentColor; margin-bottom: 24px; `;

/* ================= MAIN COMPONENT ================= */
const AdminDashboard = ({ user, setUser }) => {
  const { isDarkMode } = useTheme();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const [activeView, setActiveView] = useState('dashboard'); 
  const [allUsers, setAllUsers] = useState([]); 
  const [loading, setLoading] = useState(true);

  // Forms
  const [profileData, setProfileData] = useState({ username: user?.username || user?.name || "", email: user?.email || "" });
  const [profileMsg, setProfileMsg] = useState({ type: "", text: "" });
  const [passwordData, setPasswordData] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [passwordMsg, setPasswordMsg] = useState({ type: "", text: "" });
  const [showPwd, setShowPwd] = useState(false);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        // Only fetch staff, appraisals removed
        const usersRes = await api.get('/auth/all-staff');
        setAllUsers(usersRes.data.data || []);
      } catch (err) { 
        console.error(err);
      } finally { 
        setLoading(false); 
      }
    };
    fetchDashboardData();
  }, []);

  const displayName = `${user?.title?.trim() || ""} ${user?.firstName?.trim() || user?.name || "Admin"}`.trim();
  const initials = (user?.firstName || user?.name || "A").substring(0, 2).toUpperCase();

  const totalStaff = allUsers.length;

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put('/auth/profile', { email: profileData.email });
      if (res.data.success) {
        const fetchRes = await api.get("/auth/profile");
        if (fetchRes.data.success) {
          localStorage.setItem("user", JSON.stringify(fetchRes.data.user));
          if (setUser) setUser(fetchRes.data.user);
        }
        setProfileMsg({ type: "success", text: "Profile updated successfully!" });
      }
    } catch (err) { setProfileMsg({ type: "error", text: "Failed to update profile." }); }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) return setPasswordMsg({ type: "error", text: "Passwords don't match." });
    try {
      await api.put('/auth/change-password', { currentPassword: passwordData.currentPassword, newPassword: passwordData.newPassword });
      setPasswordMsg({ type: "success", text: "Password changed securely." });
      setPasswordData({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) { setPasswordMsg({ type: "error", text: "Failed to change password." }); }
  };

  return (
    <ThemeWrapper collapsed={collapsed} $isDarkMode={isDarkMode}>
      <NavBarSuper user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
      
      <PageContainer collapsed={collapsed}>
        <InnerWrap>
          {/* ================= HERO BANNER ================= */}
          <HeroBanner $isDarkMode={isDarkMode}>
            <HeroProfile>
              <AvatarRing>
                {user?.profilePicture ? (
                  <img src={user.profilePicture.startsWith("http") ? user.profilePicture : `${backendUrl}${user.profilePicture}`} alt="Avatar" onError={(e) => e.target.style.display="none"} />
                ) : ( <div>{initials}</div> )}
              </AvatarRing>
              <HeroTextInfo>
                <SuperBadge><FaCrown /> Admin Matrix</SuperBadge>
                <WelcomeTitle>
                  {activeView === 'dashboard' ? `Welcome back, ${displayName}` : 
                  activeView === 'profile' ? 'Profile Management' : 'Security Protocol'}
                </WelcomeTitle>
                <WelcomeSub>
                  {activeView === 'dashboard' ? 'You have administrative oversight. Monitor global organization metrics and total workforce data.' :
                  'Manage your admin-level account configurations securely.'}
                </WelcomeSub>
              </HeroTextInfo>
            </HeroProfile>
          </HeroBanner>

          {/* ================= PROFILE SETTINGS VIEW ================= */}
          {activeView === 'profile' && (
            <div>
              <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Matrix</BackButton>
              <SectionCard>
                <SectionHeader><SectionTitle><FaUserEdit style={{color: 'var(--admin-gold)'}} /> Edit Profile</SectionTitle></SectionHeader>
                {profileMsg.text && <Message type={profileMsg.type}>{profileMsg.text}</Message>}
                <Form onSubmit={handleProfileSubmit}>
                  <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Username (Locked)</Label>
                      <Input type="text" value={profileData.username} disabled />
                    </FormGroup>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Email Address</Label>
                      <Input type="email" value={profileData.email} onChange={(e) => setProfileData({...profileData, email: e.target.value})} required />
                    </FormGroup>
                  </div>
                  <SubmitBtn type="submit">Save Configurations</SubmitBtn>
                </Form>
              </SectionCard>
            </div>
          )}

          {/* ================= SECURITY VIEW ================= */}
          {activeView === 'security' && (
            <div>
              <BackButton onClick={() => setActiveView('dashboard')}><FaArrowLeft /> Return to Matrix</BackButton>
              <SectionCard>
                <SectionHeader><SectionTitle><FaShieldAlt style={{color: 'var(--admin-gold)'}} /> Security Protocol</SectionTitle></SectionHeader>
                {passwordMsg.text && <Message type={passwordMsg.type}>{passwordMsg.text}</Message>}
                <Form onSubmit={handlePasswordSubmit}>
                  <FormGroup>
                    <Label>Current Password</Label>
                    <div style={{position: 'relative'}}>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.currentPassword} onChange={(e) => setPasswordData({...passwordData, currentPassword: e.target.value})} required />
                      <button type="button" onClick={() => setShowPwd(!showPwd)} style={{position: 'absolute', right: '16px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '1.2rem'}}>{showPwd ? <FaEyeSlash/> : <FaEye/>}</button>
                    </div>
                  </FormGroup>
                  <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>New Password</Label>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.newPassword} onChange={(e) => setPasswordData({...passwordData, newPassword: e.target.value})} required />
                    </FormGroup>
                    <FormGroup style={{ flex: 1, minWidth: '250px' }}>
                      <Label>Confirm Password</Label>
                      <Input type={showPwd ? "text" : "password"} value={passwordData.confirmPassword} onChange={(e) => setPasswordData({...passwordData, confirmPassword: e.target.value})} required />
                    </FormGroup>
                  </div>
                  <SubmitBtn type="submit">Update Security Key</SubmitBtn>
                </Form>
              </SectionCard>
            </div>
          )}

          {/* ================= DASHBOARD VIEW ================= */}
          {activeView === 'dashboard' && (
            <>
              {/* 🔥 EXECUTIVE SCORECARDS */}
              <ScorecardGrid>
                <ScoreCard highlight="#3b82f6">
                  <IconWrapper bg="rgba(59, 130, 246, 0.1)" color="#3b82f6"><FaGlobe /></IconWrapper>
                  <ScoreData><ScoreNumber>{loading ? '-' : totalStaff}</ScoreNumber><ScoreText>Total Workforce</ScoreText></ScoreData>
                </ScoreCard>
              </ScorecardGrid>

              {/* GLOBAL DIRECTORY */}
              <SectionCard>
                <SectionHeader>
                  <SectionTitle><FaUsers style={{color: 'var(--admin-gold)'}} /> Global Workforce</SectionTitle>
                  <Badge>{allUsers.length} Active Staff</Badge>
                </SectionHeader>
                <CardGrid>
                  {allUsers.map((staff) => (
                    // 🔥 Navigates to /admin/goals/ instead of /super-admin/goals/
                    <ItemCard key={staff._id} onClick={() => navigate(`/admin/goals/${staff._id}`)}>
                      <CardTop>
                        <div>
                          <NameText>{staff.firstName} {staff.surname}</NameText>
                          <SubText>Role: <span>{staff.roles || 'N/A'}</span></SubText>
                          <SubText>Unit: <span>{staff.unit || 'N/A'}</span></SubText>
                        </div>
                      </CardTop>
                      <CardBottom>
                        <OutlineBtn>Inspect Performance <FaChevronRight size={10}/></OutlineBtn>
                      </CardBottom>
                    </ItemCard>
                  ))}
                </CardGrid>
              </SectionCard>
            </>
          )}
        </InnerWrap>
      </PageContainer>
      <Footer />
    </ThemeWrapper>
  );
};

export default AdminDashboard;
